define(['edge/platform/widgets/wizard/NavBarWizardBaseCtrl'], NavBarWizardBaseCtrl => {
    return ['$scope', '$element', 'StateUtils', '$rootScope', '$state',
        function ($scope, $element, StateUtils, $rootScope, $state) {

            const baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
            const ctrl = Object.create(baseNavbarCtrl);

            ctrl.init = ()=> {
                $scope.headerMessageKey = '';
                $scope.isContextPageMenuOpen = false;
                $rootScope.$on('stickyHeaderExitViewport', ctrl.closeContextPageMenu);
                $scope.$on('updateHeaderMessageKey', (event, messageKey) => {
                    $scope.updateHeaderMessageKey(messageKey);
                });

                StateUtils.beforeStateInit(ctrl._setQuoteSummaryData);
                StateUtils.afterStateInit(ctrl._checkIfSideMenuShouldBeClosed);
            };

            ///// Context menu methods ///////////////////////////////////////////
            ctrl.toggleContextPageMenu = function () {
                $scope.isContextPageMenuOpen = !$scope.isContextPageMenuOpen;
            };

            ctrl.closeContextPageMenu = function () {
                $scope.isContextPageMenuOpen = false;
            };

            ///// Header message ///////////////////////////////////////////
            $scope.updateHeaderMessageKey = (messageKey)=> {
                $scope.headerMessageKey = messageKey;
            };

            $scope.shouldShowHeaderMessage = ()=> {
                return $state.$current.name === 'quickQuote' && angular.isDefined($scope.headerMessageKey);
            };

            ///////////// Quote summary dropdown methods /////////////////////////
            ctrl._setQuoteSummaryData = function () {
                if (StateUtils.hasState('baseQnbWizard')) {
                    const data = StateUtils.dataForState('baseQnbWizard');
                    // additional checks are needed for error cases, when wizard page failed and submission is not created
                    if (data && data.flowModel && data.flowModel.snapshot) {
                        $scope.submission = StateUtils.dataForState('baseQnbWizard').flowModel.snapshot.value;
                    } else {
                        $scope.submission = null;
                    }
                } else {
                    $scope.submission = null;
                }
            };

            ctrl._isQuoteWizardVisible = function () {
                return StateUtils.hasState('baseQnbWizard');
            };

            ctrl._checkIfSideMenuShouldBeClosed = function () {
                if (!ctrl._isQuoteWizardVisible() && ctrl.isSideBarMenuVisible()) {
                    ctrl.hideSideBarMenu();
                }
            };

            return ctrl.create($scope);
        }
    ];
});



// WEBPACK FOOTER //
// ./app/js/portal/directives/NavBarCtrl.js